import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { inquiryService } from 'services/inquiryService';
import {
  Body,
  Header,
  BackButton,
  FormContainer,
  FormCard,
  TitleInput,
  ContentTextarea,
  SubmitButton
} from './InquiryCreate.styles';

function InquiryCreate() {
  const navigate = useNavigate();
  const [title, setTitle] = useState<string>('');
  const [content, setContent] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSubmit = async () => {
    if (!title.trim() || !content.trim()) {
      alert('제목과 내용을 모두 입력해주세요.');
      return;
    }

    setIsSubmitting(true);
    try {
      await inquiryService.createInquiry({
        title: title.trim(),
        content: content.trim()
      });
      alert('문의가 등록되었습니다.');
      navigate('/inquiry');
    } catch (error) {
      console.error('Error creating inquiry:', error);
      alert('문의 등록에 실패했습니다. 다시 시도해주세요.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Body>
      <Header>
        <BackButton onClick={handleGoBack}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </BackButton>
        문의하기
      </Header>

      <FormContainer>
        <FormCard>
          <TitleInput
            type="text"
            placeholder="제목을 입력해주세요."
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <ContentTextarea
            placeholder="문의 내용을 입력해주세요."
            value={content}
            onChange={(e) => setContent(e.target.value)}
          />
        </FormCard>
      </FormContainer>

      <SubmitButton
        onClick={handleSubmit}
        disabled={isSubmitting || !title.trim() || !content.trim()}
      >
        {isSubmitting ? '등록 중...' : '작성'}
      </SubmitButton>
    </Body>
  );
}

export default InquiryCreate;
